import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import { Proxy } from "core";
import PropTypes from "prop-types";
import React from "react";
import ButtonToolbar from "views/Components/ButtonToolbar";
import { GenericDateInput, GenericExpansionPanel, GenericGrid, GenericTextInput, GenericDialog, GenericRadioInput, GenericLabel, GenericDialogActions } from "views/Components/Generic";
import LoadingComponent from "views/Components/LoadingComponent";
import { GridColumnType } from "views/Constants/Constant";
import DateHelper from "core/DateHelper";
import { DialogContent, DialogTitle } from "@material-ui/core";
import Select from "react-select";
import Button from "components/CustomButtons/Button";

class MastercardSettlementReport extends React.Component {

	constructor(props) {
		super(props);

		this.state = {
			list: [],
			model: {},
			filterModel: {},
			isLoading: false
		};

		this.trxTable = React.createRef();
	}

	componentDidMount() {
		this.props.setAppLeftTitle("Mastercard Settlement Report");
		this.props.setAppCenterTitle("PREPAID CARD MANAGEMENT");
	}

	HandleChange = (name, newValue, data) => {
		const model = { ...this.state.model };

		model[name] = newValue;
		this.setState({ model });
	}

	HandleClear = () => {
		this.setState({
			model: {}
		});
	};

	HandleSearch = () => {
		const model = { ...this.state.model };
		const { showMessage } = this.props;
		this.setState({ isLoading: true });

		Proxy.POST(
			"/prepaidapi/v1.0/MastercardClearing/MastercardClearingTransactionSearch",
			model,
			(responseData) => {
			  this.setState({ isLoading: false });
 
			  if (!responseData.IsSucceeded) {
				 showMessage("error", "Error", responseData.ErrorDescription);
				 return;
			  }
			  this.setState({
				list: responseData.Item ?? [],
			  });
			},
			(error) => {
			  this.setState({ isLoading: false });
			  showMessage("error", "Error", error);
			}
		 );
	};

	ExportClick = () => {
		var trxColumns = [];
		this.trxTable.current.props.Columns.forEach(c => {
			if (c.accessor != "Actions" && c.accessor != "ED" && (c.show == undefined || c.show)) {
				trxColumns.push({ value: c.accessor, title: c.Header, columntype: c.ColumnType, type: c.type });
			}
		}, this);

		this.setState({ isDownloadDialogOpen: true, GridKeyValueList: trxColumns, ExportSelectedColumns: trxColumns });
	}

	ExcelDownload = () => {
		const { showMessage } = this.props;

		if (!this.state.ExportReportType) {
			showMessage("warning", "Export Report Type not selected", "Select Export Report Type to continue");
			return;
		}

		if (this.state.ExportReportType == "PDF" && this.state.ExportSelectedColumns.length > 15) {
			showMessage("warning", "PDF document cannot exceed 15 columns", "PDF document cannot exceed 15 columns");
			return;
		}

		this.setState({ isDownloadDialogOpen: false });

		const temp = { ...this.state.model };

		var jsonColList = [];

		var trxColumns = {};
		this.state.ExportSelectedColumns.map(c => {
			trxColumns[c.value] = { value: c.value, title: c.title, columntype: c.columntype, type: c.type };
		});
		jsonColList.push(trxColumns);

		var mytitle = "Mastercard Settlement Report";

		temp.jsonFile = {
			colmns: jsonColList,
			format: this.state.ExportReportType,
			title: mytitle
		};

		this.setState({ isLoading: true });
		Proxy.DownloadGeneratedFile(
			"/prepaidapi/v1.0/VisaClearingTransaction/MastercardClearingTransactionSearchExportDownload",
			temp,
			responseData => {
				this.setState({ isLoading: false });
				if (!responseData.IsSucceeded) {
					showMessage("error", "Error", responseData.ErrorDescription);
					return;
				}
			},
			errorMessage => {
				this.setState({ isLoading: false });
				showMessage("error", "Error", errorMessage);
			},
			this.props.showMessage
		);
	}

	ValueChanged = (name, value) => {
		this.setState({ [name]: value });
	}

	render() {
		const { alert, model, list, isLoading } = this.state;
		return (
			<div>
				<LoadingComponent Show={isLoading} />
				{alert}
				<ButtonToolbar
					ButtonList={[
						{
							Code: "Search",
							Disabled: false,
							OnClick: this.HandleSearch
						},
						{
							Code: "Clear",
							Disabled: false,
							OnClick: this.HandleClear
						},
						{  
							Code: "Export", 
							Disabled: false,
							OnClick: this.ExportClick
						}
					]}
					menuId={this.props.menuId}
					ApprovalData={this.props.ApprovalData}
					After={this.props.After}
				/>

				<GridContainer>
					<GridItem xs={12}>
						<Card className="no-radius">
							<CardBody>
								<GenericExpansionPanel Title="Main Panel">
									<GridContainer>
										<GridItem xs={12}>
											<GridContainer>
												<GridItem xs={6}>
													<GenericDateInput
														Utc
														Name="FromDate"
														LabelText="From Date"
														Value={model.FromDate ? DateHelper.ToDateInputValue(model.FromDate) : ""}
														ValueChanged={this.HandleChange}
													/>
													<GenericDateInput
														Utc
														Name="ToDate"
														LabelText="To Date"
														Value={model.ToDate ? DateHelper.ToDateInputValue(model.ToDate) : ""}
														ValueChanged={this.HandleChange}
														MinDate={model.ToDate}
													/>
												</GridItem>
												<GridItem xs={6}>
													<GenericTextInput
														Name="FileName"
														LabelMd={4}
														LabelText="File Name"
														IsText={true}
														Value={model.FileName}
														ValueChanged={this.HandleChange}
													/>
													<GenericTextInput
														Name="CardLastFourDigit"
														LabelMd={4}
														Format={"@@@@"}
														LabelText="Card Last Four Digit"
														IsText={true}
														Value={model.CardLastFourDigit}
														ValueChanged={this.HandleChange}
													/>
												</GridItem>
											</GridContainer>
										</GridItem>
									</GridContainer>
								</GenericExpansionPanel>
							</CardBody>
						</Card>
					</GridItem>
				</GridContainer>

				<GridContainer spacing={16}>
					<GridItem xs={12}>
						<Card className="no-radius">
							<CardBody>
								<GridContainer>
									<GridItem xs={12}>
										<GridItem xs={12}>
											<GenericGrid
												Data={list}
												ref={this.trxTable}
												Columns={
													[
														{
															Header: "BIN",
															accessor: "BIN"
														},
														{
															Header: "Settlement Date",
															accessor: "SettlementDate",
															type: GridColumnType.DateTime
														},
														{
															Header: "Masked Card Number",
															accessor: "MaskedCardNumber"
														},
														{
															Header: "Merchant Name",
															accessor: "MerchantName"
														},
														{
															Header: "Merchant Country",
															accessor: "MerchantCountry"
														},
														{
															Header: "Billing Amount",
															accessor: "BillingAmount",
															type: GridColumnType.Money,
															ColumnType: GridColumnType.Money,
														},
														{
															Header: "Settlement Amount",
															accessor: "SettlementAmount",
															type: GridColumnType.Money,
															ColumnType: GridColumnType.Money,
														},
														{
															Header: "Transaction Reference Number",
															accessor: "TransactionReferenceNumber"
														},			
														{
															Header: "File Name",
															accessor: "FileName"
														},
														{
															Header: "De003",
															accessor: "De003"
														},
														{
															Header: "De012",
															accessor: "De012"
														},
														{
															Header: "De014",
															accessor: "De014"
														},
														{
															Header: "De023",
															accessor: "De023"
														},
														{
															Header: "De024",
															accessor: "De024"
														},
														{
															Header: "De025",
															accessor: "De025"
														},													
														{
															Header: "De026",
															accessor: "De026"
														},
														{
															Header: "De030_1",
															accessor: "De030_1",
															type: GridColumnType.Money,
															ColumnType: GridColumnType.Money,
														},
														{
															Header: "De030_2",
															accessor: "De030_2",
															type: GridColumnType.Money,
															ColumnType: GridColumnType.Money,
														},
														{
															Header: "De031_1",
															accessor: "De031_1"
														},
														{
															Header: "De031_2",
															accessor: "De031_2"
														},
														{
															Header: "De031_3",
															accessor: "De031_3"
														},
														{
															Header: "De031_4",
															accessor: "De031_4"
														},
														{
															Header: "De031_5",
															accessor: "De031_5"
														},													
														{
															Header: "De032",
															accessor: "De032"
														},
														{
															Header: "De033",
															accessor: "De033"
														},
														{
															Header: "De037",
															accessor: "De037"
														},
														{
															Header: "De038",
															accessor: "De038"
														},
														{
															Header: "De041",
															accessor: "De041"
														},
														{
															Header: "De042",
															accessor: "De042"
														},													
														{
															Header: "De043_1",
															accessor: "De043_1"
														},
														{
															Header: "De043_2",
															accessor: "De043_2"
														},
														{
															Header: "De043_3",
															accessor: "De043_3"
														},													
														{
															Header: "De043_4",
															accessor: "De043_4"
														},
														{
															Header: "De043_5",
															accessor: "De043_5"
														},
														{
															Header: "De043_6",
															accessor: "De043_6"
														},
														{
															Header: "De049",
															accessor: "De049"
														},
														{
															Header: "De050",
															accessor: "De050"
														},
														{
															Header: "De055",
															accessor: "De055"
														},													
														{
															Header: "De063",
															accessor: "De063"
														},
														{
															Header: "De071",
															accessor: "De071"
														},
														{
															Header: "De072",
															accessor: "De072"
														},													
														{
															Header: "De073",
															accessor: "De073"
														},
														{
															Header: "De093",
															accessor: "De093"
														},
														{
															Header: "De094",
															accessor: "De094"
														},
														{
															Header: "De095",
															accessor: "De095"
														},
														{
															Header: "De100",
															accessor: "De100"
														},														
														{
															Header: "Validation Code",
															accessor: "ValidationCode"
														}
													]
												}
												ShowPagination={true}
											/>
										</GridItem>
									</GridItem>
								</GridContainer>
							</CardBody>
						</Card>
					</GridItem>
				</GridContainer>

				<GenericDialog open={this.state.isDownloadDialogOpen} fullWidth={true}>
					<DialogTitle>
						<GenericLabel Text="Select Report Type" FontSize="20px" Bold={true} />
					</DialogTitle>
					<DialogContent style={{ height: 300 }}>
						<GenericRadioInput
							Name="ExportReportType"
							LabelText="Report Type"
							IsStatic={true}
							StaticData={[{ Value: "PDF", Text: "PDF" }, { Value: "CSV", Text: "CSV" }, { Value: "EXCEL", Text: "EXCEL" }]}
							KeyValueMember="Value"
							TextValueMember="Text"
							Value={this.state.ExportReportType}
							ValueChanged={this.ValueChanged}
						/>
						<GenericLabel Text="Select Columns" FontSize="20px" Bold={true} />
						<GridItem style={{ marginTop: 20 }}>
							<Select
								value={this.state.ExportSelectedColumns}
								onChange={value => this.setState({ ExportSelectedColumns: value })}
								isMulti
								name="columns"
								getOptionLabel={d => d.title}
								options={this.state.GridKeyValueList}
								className="basic-multi-select"
								classNamePrefix="select"
							/>
						</GridItem>
					</DialogContent>
					<GenericDialogActions>
						<Button size="sm" onClick={this.ExcelDownload}>Download</Button>
						<Button size="sm" onClick={() => this.setState({ isDownloadDialogOpen: false })}>Cancel</Button>
					</GenericDialogActions>
				</GenericDialog>
			</div>
		);
	}
}

MastercardSettlementReport.propTypes = {
	classes: PropTypes.object,
	setAppLeftTitle: PropTypes.func,
	setAppCenterTitle: PropTypes.func,
	Disabled: PropTypes.bool
};

export default MastercardSettlementReport;
